import { LINE_ITEM_TYPE_LABELS, type LineItemType } from '../constants/line-item-types';

/**
 * The label for a line-item type KEY on the QuickBooks mapping screen — the
 * Line items tab and the readiness card both, so the two always name a key the
 * same way.
 *
 * NOT `getLineItemTypeLabel`, on purpose. That helper resolves legacy aliases
 * (`vacuum_drifting` and `drift_gauge` both read "Drift"), which is right on a
 * ticket and wrong here: a QuickBooks mapping is keyed on the STORED spelling,
 * so `vacuum_drifting` is its own row with its own binding, and labelling it
 * "Drift" points the office at the `drift` row, which may already be mapped.
 *
 * A current enum value gets its display label; anything else (a legacy alias,
 * a key this build does not know) is shown as the key itself, underscores as
 * spaces — never folded into another key's name.
 */
export function qboLineItemTypeLabel(key: string): string {
  if (Object.prototype.hasOwnProperty.call(LINE_ITEM_TYPE_LABELS, key)) {
    return LINE_ITEM_TYPE_LABELS[key as LineItemType];
  }
  return key.replace(/_/g, ' ');
}
